import React from 'react'
import styled from 'styled-components'
import { Borders, Colors, FontWeights, INTEGRAL_SYMBOL } from '../../constants'
import { BigNumber } from 'ethers'
import { formatCurrency } from '../../model'
import { TokenRewards } from '../../providers/apiTokenRewards/model'

interface Props {
  className?: string
  apiTokenRewards?: TokenRewards
  onClick: () => void
}

export function TokenRewardsCounter({ className, apiTokenRewards, onClick }: Props) {
  let total: BigNumber | undefined
  if (apiTokenRewards) {
    const { lpRewards, tradeRewards } = apiTokenRewards
    total = Object.keys(lpRewards).reduce((memo, address) => {
      const pair = lpRewards[address]
      return memo.add(pair.tokenRewards.total)
    }, BigNumber.from(0))
    total = total.add(tradeRewards.tokenRewards.total)
  }

  const totalTokenRewards = total ? formatCurrency(18, total, 6) : '-'

  return (
    <Counter className={className} onClick={onClick}>
      <span>{totalTokenRewards}</span>
      <strong>{INTEGRAL_SYMBOL}</strong>
    </Counter>
  )
}

const Counter = styled.button`
  padding: 5px 8px;
  display: inline-flex;
  align-items: center;
  color: ${Colors.White};
  font-size: 13px;
  background: none;
  border: 1px solid ${Colors.Gray};
  border-radius: ${Borders.Radius};
  outline: 0;
  cursor: pointer;

  span {
    margin-right: 4px;
    font-weight: ${FontWeights.Regular};
  }

  &:hover {
    background-color: ${Colors.Hover};
  }
`
